import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Forum() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">

{/*
        <Box my={8}>
          <Typography className="font-weight-bold my-3 text-danger" variant="h5" component="h2">
            【３月例会中止のお知らせ】
          </Typography>
          <div className="text-danger">
          　３月１８日（水）に八戸パークホテルで開催を予定しておりました「デーリー東北政経懇話会３月例会」は、新型コロナウイルス感染症が拡大している状況を受け、会員の皆様の健康と安全を考慮し、中止させていただきます。<br />
          　例会を楽しみにしてくださいました皆様には大変ご迷惑をおかけいたします。深くおわび申し上げますとともに、ご理解いただきますようお願い申し上げます。<br />
          　今回中止となった講演分は、新年度中に振り替えて追加開催させていただくことで検討しております。４月例会の開催につきましても対応が決まり次第、改めてご案内させていただきますので、よろしくお願い申し上げます。<br />
          </div>
        </Box>
*/}
{/*
        <Box my={8} align="left">
          <Paper className="p-3">
            <Typography className="font-weight-bold my-3 text-danger" variant="h5" component="h2">
              【例会休止のお知らせ】
            </Typography>
            <div className="text-danger">
              　皆さまには日頃よりご理解とご協力を賜り、心より感謝申し上げます。<br />
              　当会は、このたびの新型ウイルス感染拡大防止のため、当面、例会を休止といたします。今後につきましては情勢を注視し、例会再開の際には会員の皆さまに個別にご案内するとともに、新聞紙上、当サイトでお知らせいたします。なにとぞご了承ください。<br />
              <div className="text-right">（事務局）</div>
            </div>
          </Paper>
        </Box>
*/}

{/*
        <Box my={8} align="left">
          <Paper className="p-3">
            <Typography className="font-weight-bold my-3 text-danger" variant="h5" component="h2">
              【例会再開のお知らせ】
            </Typography>
            <div className="text-danger">
              　皆さまには平素より当会運営にご理解とご協力を賜り、心より感謝申し上げます。<br />
              　当会は新型コロナウイルス感染症の拡大を受け、上期例会を休会としてきましたが、感染予防対策を講じた上で１０月例会より再開します。ご不便をお掛けして大変申し訳ありませんでした。皆さまのご来場、心よりお待ちしております。<br />
              <div className="text-right">（事務局）</div>
            </div>
          </Paper>
        </Box>
*/}

        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            政経懇話会
          </Typography>
          　デーリー東北政経懇話会は会員制のセミナーです。1970（昭和45）年に地域の各界各層からの要望とご支援によって八戸地区で発足。その5年後には上北地区（十和田市、三沢市で持ち回り開催）を開設いたしました。交通アクセスの向上に伴い2006年4月からは上北地区を八戸地区に統合しました。<br/>
          　国内外の動きがめまぐるしく変動するなか、世界と日本の情報を迅速かつ的確にとらえることが一層重要になってきています。<br/>
          　当会では時局に合った講師を厳選し、政治や経済の動向を中心に会員の皆様に最新情報をお届けしています。<br/>
        </Box>

        <Box my={8}>
          <Grid spacing={8} container direction="row" justify="center">
            <Grid item xs={12} md={6}>

              <a id="forum-about" className="anchor"></a>
              <Box my={4}>
                <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                  例　会
                </Typography>
                ▽各例会では中央で活躍する一流の講師を招き90分の講演を通じてホットな情報を提供します。<br/>
                ▽例会は11時50分から会食、12時20分から講演を行います。<br/>
                ▽各例会では、会員ご本人の出席ができない場合、代理出席ができます。<br/>
                ▽年10回開催（5、11月は休会）しています。このうち6月と12月は特別例会として講演終了後に会員相互の親睦を図るため懇親パーティーを開きます。<br/>
                ▽特別例会の懇親パーティーでは会員ご本人のほかご家族、ご友人などお一人の同伴出席をいただいています。<br/>
              </Box>
 
              <a id="forum-special" className="anchor"></a>
              <Box my={4}>
                <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                  特　典
                </Typography>
                <dl>
                  <dt><ArrowRightIcon />「政経週報」を毎週お届けします。</dt>
                  <dd>
                    　当会では耳から得る情報（講演）のほか、目から得る情報として、国内外のニュースを側面からとらえた情報冊子「政経週報」を毎週月曜日に共同通信社の全国政懇協議会事務局から直接郵送しています。
                  </dd>
                  <dt><ArrowRightIcon />「プレジデント」を月２回お届けします。</dt>
                  <dd>
                    　プレジデント社のビジネス情報誌「プレジデント」を月２回、同社から直接、会員の皆様にお届けしております。
                  </dd>
                </dl>
              </Box>

              <a id="forum-entry" className="anchor"></a>
              <Box my={4}>
                <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                  入会のご案内
                </Typography>
                本会は会員制です。企業・団体のほか、個人でも入会でき、随時受け付けています。入会申し込み、問い合わせはデーリー東北政経懇話会事務局＝電話０１７８（８０）７２９９＝へ。<br/>
                <Box my={2} className="font-weight-bold">
                  入会金：5,000円（消費税別）<br/>
                  月会費：9,000円（消費税別）<br/>
                  <span className="font-weight-normal">（食事代、資料代等一切を含む）</span><br/>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              {/*
              <Typography className="font-weight-bold text-center bg-dark rounded text-white my-3 py-1 px-3" variant="subtitle1" component="div">
                デーリー東北政経懇話会３月例会中止のお知らせ
              </Typography>
              　３月２８日（月）に八戸グランドホテルで開催を予定しておりました「デーリー東北政経懇話会３月例会」は、講師の小和田哲男先生の体調不良により、中止とさせていただきます。<br/>
              <br/>
              　講演を楽しみにしていてくださった皆さまには深くおわび申し上げますとともに、何とぞご理解いただきますようお願い申し上げます。<br/>
              <br/>
              　今回中止とした分の振替開催については決まり次第、改めてご案内いたします。<br/>
              <br/>
              　お問い合わせはデーリー東北政経懇話会事務局＝電話0178(80)7299、平日午前９時半～午後５時＝までお願いいたします。<br/>
              */}

              <Typography className="font-weight-bold text-center bg-dark rounded text-white my-3 py-1 px-3" variant="subtitle1" component="div">
                デーリー東北政経懇話会9月例会のお知らせ
              </Typography>
              <img src="/images/forum/seikon-202609.jpg" width="120" className="float-left m-3" />
              　日本プルーフポイント㈱チーフエバンジェリストの増田(そうた)幸(ゆき)美(み)氏を講師に迎え、八戸プラザホテルで開催します。演題は「敵を知る　 ～フロンティアAIが変えるサイバー攻撃と防御の最前線」です。<br/>
            	　ロシアからの不正アクセスによるサイバー攻撃で、冷凍食品大手ニチレイのシステム障害が発生したことが記憶に新しいところですが、生成人工知能（AI）の飛躍的な進歩もあり、企業への身代金要求型のコンピューターウイルス（ランサムウエア）被害は拡大の一途を辿っています。<br/>
              　サイバーセキュリティの分野で活躍され、警察大学校の講師も務められている増田氏から、サイバー被害を未然に防ぐ対策などについてお話ししていただきます。<br/>
              <dl>
                <dt>【日時】</dt>
                <dd>
                　2026年9月16日（水）<br/>
                　午前11時50分～昼食<br/>
                　午後0時20分～講演会<br/>
                </dd>
                <dt>【会場】</dt>
                <dd>
                  　八戸プラザホテル（八戸市柏崎１丁目６−６）
                </dd>
                <dt>【講師紹介】</dt>
                <dd>
                  　早稲田大学首席卒業。日本オラクル（株）システムコンサルタントとして業務システムの構築を手掛けた後、ファイア・アイ（株）で脅威インテリジェンスのスペシャリストとして従事。サイバーリーズン(株)エバンジェリストとして活動。2018年千葉県警サイバーセキュリティ対策テクニカルアドバイザー。22年警察大学校講師。現在、日本プルーフポイント（株）においてサイバーセキュリティの啓発活動をおこなっている。
                </dd>
              </dl>

              {/*               
              <Box my={4} textAlign="center">
                <Grid className="p-3" spacing={0} container direction="row" justify="center">
                  <Grid item xs={12} md={8}>
                    <CustomButton href="/forum/history" className="px-4 m-2 d-block" size="large" themeColor={red}>
                      過去の例会講師と演題
                    </CustomButton>
                  </Grid>
                </Grid>
              </Box>
              */}
            </Grid>
          </Grid>
        </Box>

      </div>
    </div>
  );
}

export default Forum;
